import React from 'react';
import PropTypes from 'prop-types';
import style from './style.css';

class ConstraintInput extends React.Component {

  byGroup() {
    const { filters } = this.props;

    return filters.allIds.reduce((acc, id) => {
      const { group } = filters.byId[id];
      acc[group] = acc[group] || [];
      acc[group].push(filters.byId[id]);
      return acc;
    }, {});
  }

  filterOptions () {
    const byGroup = this.byGroup();

    return Object.keys(byGroup).map((group, index) => {
      return (
        <optgroup key={ index} label={ group }>
          {
            byGroup[group].map((filter, index) => {
              return (
                <option key={ index } value={ filter.id}>
                  { filter.title }
                </option>
              );
            })
          }
        </optgroup>
      );
    });
  }

  render() {
    const { value, filters, disabled } = this.props;

    return (
      <div className={ style.container }>
        { value.map((list, i) => {
          return (
            <div key={ i }>
              <div  className={ style.row}>
                {
                  list.map((id, j) => {
                    const item = filters.byId[id];

                    if (!item) {
                      return null;
                    }

                    return (
                      <span key={ j } className={ style.item }>{ item.title }
                        <button
                          className={ style.deleteButton }
                          onClick={ this.onDeleteClick.bind(this, i, j)}
                          disabled={ disabled }
                        >&times;</button>
                      </span>
                    );
                  })
                }
                <select
                  className={ style.select }
                  value="selectTitle"
                  onChange={ this.onChange.bind(this, i) }
                  disabled={ disabled }
                >
                  <option disabled={ true } value="selectTitle">Lägg till filter</option>
                  { this.filterOptions() }
                </select>
              </div>
              <span className={ style.label }>eller</span>
            </div>
          );
        })}
        <div  className={ style.row}>
          <select
            className={ style.select }
            value="selectTitle"
            onChange={ this.onChange.bind(this, value.length) }
            disabled={ disabled }
          >
            <option disabled={ true } value="selectTitle">Lägg till filter</option>
            { this.filterOptions() }
          </select>
        </div>
      </div>
    );
  }

  onChange(row, event) {
    const { value } = event.target;
    const { onAdd } = this.props;
    onAdd(row, value);
  }

  onDeleteClick(row, column) {
    const { onDelete } = this.props;
    onDelete(row, column);
  }
}

ConstraintInput.propTypes = {
  value: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  onAdd: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default ConstraintInput;



// WEBPACK FOOTER //
// ./client/src/components/constraint-input/index.js